import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './solvegame.css';
import trueSound from './assets/true.wav';
import wrongSound from './assets/wrong.wav';
import solveSound from './assets/Solve-Sound.wav';
import countdownSound from './assets/Countdown-15s.wav';
import Swal from 'sweetalert2';
import { db } from '../Firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

// ตั้งค่า SweetAlert2 ให้แสดงค้างไว้
const Toast = Swal.mixin({
  showConfirmButton: true,
  showDenyButton: false,
  showCancelButton: false,
  showCloseButton: false,
  allowOutsideClick: false,
  allowEscapeKey: false,
  timer: undefined,
  timerProgressBar: false,
  backdrop: true,
  heightAuto: false
});

function SolveGame({ userData, onUserUpdate, visible, onClose }) {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  // ข้อมูลภาพโจทย์และคำตอบทั้งหมด 21 ข้อ
  const problemSets = [
    { id: 0, image: require('./assets/solve-0.jpg'), answer: '13' },
    { id: 1, image: require('./assets/solve-1.jpg'), answer: '16' },
    { id: 2, image: require('./assets/solve-2.jpg'), answer: '17' },
    { id: 3, image: require('./assets/solve-3.jpg'), answer: '10' },
    { id: 4, image: require('./assets/solve-4.jpg'), answer: '37' },
    { id: 5, image: require('./assets/solve-5.jpg'), answer: '15' },
    { id: 6, image: require('./assets/solve-6.jpg'), answer: '21' },
    { id: 7, image: require('./assets/solve-7.jpg'), answer: '20' },
    { id: 8, image: require('./assets/solve-8.jpg'), answer: '7' },
    { id: 9, image: require('./assets/solve-9.jpg'), answer: '22' },
    { id: 10, image: require('./assets/solve-10.jpg'), answer: '56' },
    { id: 11, image: require('./assets/solve-11.jpg'), answer: '52' },
    { id: 12, image: require('./assets/solve-12.jpg'), answer: '24' },
    { id: 13, image: require('./assets/solve-13.jpg'), answer: '23' },
    { id: 14, image: require('./assets/solve-14.jpg'), answer: '88' },
    { id: 15, image: require('./assets/solve-15.jpg'), answer: '59' },
    { id: 16, image: require('./assets/solve-16.jpg'), answer: '28' },
    { id: 17, image: require('./assets/solve-17.jpg'), answer: '27' },
    { id: 18, image: require('./assets/solve-18.jpg'), answer: '72' },
    { id: 19, image: require('./assets/solve-19.jpg'), answer: '85' },
    { id: 20, image: require('./assets/solve-20.jpg'), answer: '69' }
  ];

  const [currentProblem, setCurrentProblem] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [score, setScore] = useState(0);
  const [gameStarted, setGameStarted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [gameEnded, setGameEnded] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [infoShown, setInfoShown] = useState(false);

  // Function to safely stop audio
  const stopAudio = () => {
    if (audioRef.current) {
      try {
        // หยุดการเล่นแบบ loop ก่อน
        audioRef.current.loop = false;
        // หยุดเสียง
        audioRef.current.pause();
        // รีเซ็ตเวลา
        audioRef.current.currentTime = 0;
        // ล้าง event listeners
        audioRef.current.onended = null;
        audioRef.current.onerror = null;
        // ล้าง reference
        audioRef.current = null;
        setIsAudioPlaying(false);
      } catch (error) {
      }
    } else {
    }
  };

  // Function to safely play audio
  const playAudio = async (audioSrc, loop = false) => {
    try {
      // Stop any existing audio first
      stopAudio();
      
      // Create new audio instance
      const audio = new Audio(audioSrc);
      
      // Set loop property before playing
      audio.loop = loop;
      
      // Wait for audio to be ready
      await audio.play();
      
      audioRef.current = audio;
      setIsAudioPlaying(true);
      
      // Handle audio end
      audio.onended = () => {
        if (!loop) {
          setIsAudioPlaying(false);
        }
      };
      
      // Handle audio errors
      audio.onerror = () => {
        setIsAudioPlaying(false);
      };
      
    } catch (error) {
      setIsAudioPlaying(false);
    }
  };

  // ฟังก์ชันสำหรับ update Bonus-Solve เมื่อกดปุ่มเริ่มเกมส์
  const updateBonusSolve = async () => {
    if (userData?.username) {
      try {
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const currentData = docSnap.data();
          
          // คำนวณ Bonus-Solve = show-silver + show-gold + show-diamond
          const showSilver = currentData['show-silver'] || 0;
          const showGold = currentData['show-gold'] || 0;
          const showDiamond = currentData['show-diamond'] || 0;
          const bonusSolve = showSilver + showGold + showDiamond;


          await updateDoc(userRef, {
            'Bonus-Solve': bonusSolve
          });

        } else {
        }
      } catch (error) {
        console.error("❌ Error updating Bonus-Solve:", error);
      }
    } else {
    }
  };

  // ดึงข้อมูล Solve-Level จาก Database เมื่อเริ่มเกม
  useEffect(() => {
    if (visible && !gameStarted) {
      getCurrentSolveLevel();
    }
  }, [visible, gameStarted]);

  const getCurrentSolveLevel = async () => {
    if (userData?.username) {
      try {
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          const solveLevel = userData.SolveLevel || 0;
          setCurrentLevel(solveLevel);
          
          // ตั้งค่าคำถามตามระดับปัจจุบัน
          setCurrentProblem(solveLevel);
        }
      } catch (error) {
        console.error("Error getting Solve-Level:", error);
        setCurrentLevel(0);
        setCurrentProblem(0);
      }
    }
  };

  // แสดง information เมื่อเริ่มต้น
  useEffect(() => {
    if (visible && !gameStarted && currentLevel >= 0 && !infoShown) {
      // เล่นเสียง Solve-Sound.wav แบบวนไปเรื่อยๆ
      playAudio(solveSound, true);
      
      Toast.fire({
        title: '🏆 Sense Maths',
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <h3 style="color: #2c3e50; margin-bottom: 15px; margin-left: 18px;">📋 กติกาการเล่น:</h3>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ดูภาพโจทย์และหาคำตอบที่ถูกต้อง</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• พิมพ์คำตอบในช่องที่กำหนด</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• เวลาในการทำ: 60 วินาที</p>
            <p style="margin: 8px 0; margin-left: 18px; font-size: 18px;">• ตอบถูกจะได้ 30 คะแนน</p>
          </div>
        `,
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: '🎮 เริ่มเกม!',
        confirmButtonColor: '#28a745',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(async (result) => {
        if (result.isConfirmed) {
          // หยุดเสียงเมื่อเริ่มเกม
          stopAudio();
          
          // Update Bonus-Solve เมื่อกดปุ่มเริ่มเกมส์
          await updateBonusSolve();
          
          setGameStarted(true);
          setTimeLeft(60);
          // เล่นเสียง countdown เมื่อเริ่มเกม
          playAudio(countdownSound);
        }
      });
      
      // Mark info as shown to prevent it from showing again
      setInfoShown(true);
    }
  }, [visible, gameStarted, currentLevel, infoShown]);

  // Timer countdown
  useEffect(() => {
    if (gameStarted && timeLeft > 0 && !gameEnded) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (timeLeft === 0 && !gameEnded) {
      // เมื่อเวลาหมด ให้แสดงว่าตอบผิด
      setGameEnded(true);
      playAudio(wrongSound);
      
      Toast.fire({
        title: '⏰ เวลาหมด!',
        html: `
          <div style="text-align: center; margin: 20px 0;">
            <p style="font-size: 18px; color: #e74c3c;">เวลาหมดแล้ว</p>
            <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
            <p style="font-size: 16px; color: #7f8c8d;">ระดับถัดไป: ${Math.min(currentLevel + 2, 21)}/21</p>
          </div>
        `,
        icon: 'warning',
        confirmButtonText: 'ตกลง',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false
      }).then(() => {
        // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
        saveScoreAndNavigate(0);
      });
    }
  }, [gameStarted, timeLeft, gameEnded, currentLevel]);

  const handleAnswer = () => {
    // ป้องกันการเรียกซ้ำ
    if (gameEnded) return;
    
    // หยุด timer ทันทีเมื่อตอบคำถาม
    setGameEnded(true);
    
    if (userAnswer.trim() === problemSets[currentProblem].answer) {
      playAudio(trueSound);
      
      const finalScore = 30; // คะแนนที่ได้เมื่อตอบถูก
      setScore(finalScore);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '🎉 ถูกต้อง!',
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p style="font-size: 18px; color: #27ae60;">ยินดีด้วย! คุณตอบถูก</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">${finalScore} คะแนน</span></p>
              <p style="font-size: 16px; color: #7f8c8d;">ระดับถัดไป: ${Math.min(currentLevel + 2, 21)}/21</p>
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then((result) => {
          // บันทึกคะแนนและออกจากโปรแกรมไปหน้า Exercises
          saveScoreAndNavigate(finalScore);
        });
      }, 100);
    } else {
      playAudio(wrongSound);
      
      // ใช้ setTimeout เพื่อให้แน่ใจว่า state ได้อัปเดตแล้ว
      setTimeout(() => {
        Toast.fire({
          title: '❌ ผิด!',
          html: `
            <div style="text-align: center; margin: 20px 0;">
              <p style="font-size: 18px; color: #e74c3c;">คำตอบไม่ถูกต้อง</p>
              <p style="font-size: 20px; font-weight: bold; color: #2c3e50;">คะแนนที่ได้: <span style="color: #e74c3c;">0 คะแนน</span></p>
              <p style="font-size: 16px; color: #7f8c8d;">ระดับถัดไป: ${Math.min(currentLevel + 2, 21)}/21</p>
            </div>
          `,
          icon: 'error',
          confirmButtonText: 'ตกลง',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          focusConfirm: true,
          returnFocus: false
        }).then(() => {
          // ออกจากโปรแกรมไปหน้า Exercises
          saveScoreAndNavigate(0);
        });
      }, 100);
    }
  };

  const saveScoreAndNavigate = async (finalScore) => {
    // บันทึกคะแนนและเพิ่ม Solve-Level
    if (userData?.username) {
      try {
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const currentData = docSnap.data();
          const newScore = (currentData.score || 0) + finalScore;
          
          // เพิ่ม Solve-Level + 1 (แต่ไม่เกิน 20 เพราะเป็น 0-based)
          const currentSolveLevel = currentData.SolveLevel || 0;
          const newSolveLevel = Math.min(currentSolveLevel + 1, 20);

          await updateDoc(userRef, {
            score: newScore,
            SolveLevel: newSolveLevel
          });

          if (onUserUpdate) {
            onUserUpdate(userData.username);
          }
        }
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    }

    // หยุดเสียงก่อนปิดเกม
    stopAudio();
    
    // Reset info shown flag for next time
    setInfoShown(false);
    
    // ปิดเกมและออกจากโปรแกรม
    onClose();
  };

  const endGame = async () => {
    setGameEnded(true);
    const timeBonus = timeLeft;
    const finalScore = score + timeBonus;

    await Toast.fire({
      title: 'เกมจบ!',
      html: `
        <p>คะแนนพื้นฐาน: ${score} คะแนน</p>
        <p>โบนัสเวลา: ${timeBonus} คะแนน</p>
        <p><strong>คะแนนรวม: ${finalScore} คะแนน</strong></p>
      `,
      icon: 'success',
      confirmButtonText: 'ตกลง',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false
    });

    // บันทึกคะแนน
    if (userData?.username) {
      try {
        const userRef = doc(db, "Competition-Training", userData.username);
        const docSnap = await getDoc(userRef);

        if (docSnap.exists()) {
          const currentData = docSnap.data();
          const newScore = (currentData.score || 0) + finalScore;

          await updateDoc(userRef, {
            score: newScore,
            bonus: false
          });

          if (onUserUpdate) {
            onUserUpdate(userData.username);
          }
        }
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    }

    // หยุดเสียงก่อนปิดเกม
    stopAudio();
    
    // Reset info shown flag for next time
    setInfoShown(false);
    
    onClose();
  };

  const handleBackToExercies = () => {
    // หยุดเสียงก่อนปิดเกม
    stopAudio();
    
    // Reset info shown flag for next time
    setInfoShown(false);
    
    onClose();
  };

  // Cleanup audio when component unmounts or when closing
  useEffect(() => {
    return () => {
      stopAudio();
    };
  }, []);

  if (!visible) return null;

  if (!gameStarted) return null;

  return (
    <div className="solve-game-modal">
      <div className="solve-game-content">
        <div className="game-header">
          <h2>🏆 Sense Maths</h2>
          <div className="game-stats">
            <div className="time-display">⏰ เวลาคงเหลือ: {timeLeft} วินาที</div>
          </div>
        </div>

        <div className="problem-container">
          <div className="problem-image">
            <img 
              src={problemSets[currentProblem].image} 
              alt={`Problem ${currentProblem + 1}`}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>

          <div className="answer-section">
            <div className="input-group">
              <input
                type="number"
                inputMode="numeric"
                value={userAnswer}
                onChange={(e) => {
                  setUserAnswer(e.target.value);
                }}
                placeholder="ใส่คำตอบที่นี่"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && userAnswer.trim() && !gameEnded) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleAnswer();
                  }
                }}
                autoFocus
                disabled={gameEnded}
              />
              <button onClick={handleAnswer} disabled={!userAnswer.trim() || gameEnded}>
                ตอบ
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolveGame;